import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS, SHADOWS } from '@components/web/src/styles';

export const LanguageDropdownList = styled(Flexbox)`
  background: ${COLORS.base.white};
  box-shadow: ${SHADOWS.lg};
  position: absolute;
  top: 43px;
  left: 0;
  border-radius: 0 0 8px 8px;
  min-width: fit-content;
`;

export const LanguageListWrapper = styled(Flexbox)`
  padding: 6px 8px;
  cursor: pointer;
`;
